import mountain from '@/packages/sxm/mountain';
import { useCallback, useEffect, useState } from 'react';

export default function useLiveChannel(channelList: string[], callback: (arg0: MountainResponse) => void) {
    const [timer, setTimer] = useState(0);

    const getChannels = useCallback(
        async () => {
            const channels = await mountain(channelList);
            return channels;
        },
        [channelList]
    )

    useEffect(() => {
        if (timer === 0 && channelList.length > 0) {
            getChannels().then((channelData) => {
                setTimer(channelData.nextCallAfter);

                const timeout = setTimeout(() => {
                    setTimer(0);
                }, channelData.nextCallAfter);

                callback(channelData);

                return () => clearTimeout(timeout);
            });
        }
        
    }, [timer, callback, channelList.length, getChannels]);
}
